import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { OnboardingGuide } from '../../models/agent.models';

@Component({
  selector: 'app-chat-onboarding-guide',
  templateUrl: './chat-onboarding-guide.component.html',
  styleUrls: ['./chat-onboarding-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatOnboardingGuideComponent implements OnChanges {
  @Input({ required: true }) spec!: string;

  guide: OnboardingGuide | null = null;
  fallbackRaw: string | null = null;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnChanges(): void {
    try {
      this.guide = JSON.parse(this.spec) as OnboardingGuide;
      this.fallbackRaw = null;
    } catch {
      this.fallbackRaw = this.spec;
      this.guide = null;
    }
  }

  html(text: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
